
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invoice-discounting-for-smes",
      function () {
        return require("private-next-pages/invoice-discounting-for-smes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invoice-discounting-for-smes"])
      });
    }
  